type ThemeValue = string | number | Record<string, any>

export function generateCSSVariablesByTheme(obj: Record<string, ThemeValue>, prefix = ''): string {
  return `${Object.entries(obj)
    .map(([key, value]) => {
      const variableName = prefix ? `${prefix}-${key}` : key

      if (typeof value === 'object' && value !== null) {
        return generateCSSVariablesByTheme(value, variableName)
      }

      return `--${variableName}: ${value}`
    })
    .join(';\n')}`
}
